import React, { useState } from 'react';
import PropTypes from 'prop-types';
import css from './SignInForm.css';
import StyledButton from 'common/StyledButton';
import Input from './Input';
import useStarfishAPI from '../hooks/useStarfishAPI';
import { validateEmail } from '../utils/kiosk';
import VisuallyHiddenSpan from '../common/VisuallyHiddenSpan';

function ProspectiveSignInForm(props) {
  const [email, setEmail] = useState("");

  // Declarative callbacks for the starfish API
  const [{ data, success, pending, error }, callAPI] = useStarfishAPI();

  if ( success ) props.onSignIn({...data, studentEmail: email}, true);

  const isButtonDisabled = () => pending || !validateEmail(email);

  const onSubmit = async e => {
    e.preventDefault();
    if ( isButtonDisabled() ) return;
    const URL = '../kiosk/signInProspectWalkIn.html';
    await callAPI(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        secondaryEmail: email,
        isProspectiveStudent: true,
        kioskId: props.kioskId,
        kioskUid: props.kioskUid,
        shortForm: true
      })
    });

    // Scroll top when call is done so user can check any error message
    if (props.contentRef.current.scrollTo) {
      props.contentRef.current.scrollTo(0, 0);
    }
  };

  // Only display the error if it exists and API call is not pending
  props.setError(error && !pending ? error : "");

  return (
    <form className={css['form']} onSubmit={onSubmit}>
      <Input
        id="kiosk-prospective-student-email-field"
        autoFocus
        type="text"
        placeholder="Email address"
        value={email}
        label="Email address"
        onChange={e => setEmail(e.target.value)}
        hint="Ex: name@email.com"
        errorMessage={error ? "Ex: name@email.com" : ""}
      />
      <StyledButton
        style={{margin: 0}}
        type="submit"
        className={css['signin-button']}
        aria-disabled={isButtonDisabled()}>
        {pending ? "Signing in..." : "Sign in"}
      </StyledButton>
      <VisuallyHiddenSpan 
        text={validateEmail(email) ? "Hit the sign in button to proceed." : "Please provide a valid e-mail."}
        ariaLive="assertive"
      />
    </form>
  );
}

ProspectiveSignInForm.propTypes = {
  kioskId: PropTypes.number.isRequired,
  kioskUid: PropTypes.string.isRequired,
  onSignIn: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  contentRef: PropTypes.object.isRequired,
};

export default ProspectiveSignInForm;
